
import React from 'react'
import {Component} from 'react'

import Tree from 'cms_plugins/zitat_display/js/components/Tree'
import SearchLink from 'cms_plugins/expert_search/js/components/SearchLink'


class Table extends Component {

    constructor(props) {
        super(props);

        this.state = {
            "orderCol": 0,
            "orderDir": 0,
        }
    }

    onHeaderClick = (index) => {
        this.setState((state, props) => {
            if (index === state.orderCol)
                return {orderDir: 1-state.orderDir};
            return {orderCol: index, orderDir: 0};
        });
    };

    handleRowClick = (event, pk) => {
        event.preventDefault();
        event.stopPropagation();
        if (this.props.onRowClick)
            this.props.onRowClick(pk);
    };

    render()
    {
        const {headers, rows, columnTypes} = this.props;

        const sort_func = this.state.orderDir === 0
            ? (l, r) => (l.items[this.state.orderCol] > r.items[this.state.orderCol]) ? 1 : -1
            : (l, r) => (l.items[this.state.orderCol] < r.items[this.state.orderCol]) ? 1 : -1;

        const value_decorator = (value, column) => (
            !columnTypes
                ? value
                : <SearchLink
                      text={value}
                      model={columnTypes[column].model}
                      field={columnTypes[column].field}
                  />
        );

        return (
            <table className={"results"}>
                <thead>
                <tr>
                    <th/>
                    {headers ? headers.map((h, i) => (
                        <th key={i}
                            onClick={()=>{this.onHeaderClick(i)}}
                            className={this.state.orderCol===i ? "sort-dir-"+this.state.orderDir : ""}
                        >{h}</th>
                    )) : null}
                </tr>
                </thead>
                <tbody>
                {rows ? rows.sort(sort_func).map((row, i) => (
                    <tr key={i}  onClick={(e)=>{this.handleRowClick(e, row.pk)}}>
                        <td className={"view"}/>
                        {row.items.map((x, column) => (
                            <td key={column}>{
                                typeof x === "object"
                                    ? <ul>{x.map((y, j) => (
                                        <li key={j}>{value_decorator(y, column)}
                                        </li>))}
                                      </ul>
                                    : value_decorator(x, column)
                            }</td>
                        ))}
                    </tr>
                )) : null}
                </tbody>
            </table>
        );
    }
}

export default Table;


// WEBPACK FOOTER //
// ./cms_plugins/expert_search/js/components/Table.js